import { AbstractLogger } from "./AbstractLogger";
import { getAccessToken } from "@newsenec/auth-provider";
import { detect } from "detect-browser";

export interface LoggingData {
    microFrontend: string;
    message: string;
    errorTraceId?: string;
    browserInfo?: string;
    stackTrace?: string;
}

/**
 * Logs to the FPP backend.
 */
export class FppBackendLogger extends AbstractLogger {
    private readonly logUrl = new URL(location.origin + "/api/fpp/log");

    logError = async (message: string, stackTrace?: string | undefined, errorTraceId?: string | undefined) => {
        const token = await getAccessToken();
        const loggingData = this.createLoggingData(message, stackTrace, errorTraceId);

        // no error handling for error logging
        await fetch(this.logUrl, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + token,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(loggingData),
        });
    };

    private createLoggingData = (message: string, stackTrace?: string, errorTraceId?: string): LoggingData => {
        return {
            microFrontend: this.microFrontend,
            message,
            errorTraceId,
            browserInfo: this.browserInfo(),
            stackTrace,
        };
    };

    private browserInfo = (): string | undefined => {
        const browser = detect();
        return browser?.version && browser.os ? `${browser.name} ${browser.version} | ${browser.os}` : undefined;
    };
}
